
//== GLightbox (https://github.com/biati-digital/glightbox)
//
//##

import GLightbox from 'glightbox';

(function() {
	if (datamintsConfig.lightbox) {
		new GLightbox({
			selector: 'a.lightbox'
		});
	}
})();
